import { otherEndpoint, parseToken } from '../lib/format.js'

/**
 * Build AssociationsColumn groups from raw associations + resolved records.
 * ctx = { onOpenToken, candidatesByType, onLink, onUnlink }
 * spec = [{ title, type, label(record), sub(record) }]
 */
export function buildGroups(selfToken, associations, recordsByToken, ctx, spec) {
  const { onOpenToken, candidatesByType = {}, onLink, onUnlink } = ctx
  return spec.map(({ title, type, label, sub }) => {
    const items = associations
      .map((a) => otherEndpoint(a, selfToken))
      .filter((tok) => tok && parseToken(tok).type === type)
      .map((tok) => {
        const rec = recordsByToken[tok] || {}
        return {
          id: parseToken(tok).id,
          token: tok,
          label: label(rec),
          sub: sub(rec),
          onOpen: () => onOpenToken(tok),
        }
      })
    const candidates = candidatesByType[type]
    return {
      title,
      items,
      candidates: Array.isArray(candidates) ? candidates : undefined,
      labelOf: label,
      onLink: Array.isArray(candidates) && onLink ? (record) => onLink(type, record) : undefined,
      onUnlink: onUnlink ? (item) => onUnlink(type, item.token) : undefined,
    }
  })
}
